import http from './http'

export default {
  get: getContact,
  getAuths: getUserAuths,
  getPreferences: getUserPreferences,
  updatePreferences: updateContactPreferences,
}

async function getContact(contactId) {
  if (contactId) {
    let url = 'TzbContacts/' + contactId
    // url += '?filter[include]=contactPreferences'
    const { data } = await http.get(url)
    const contact = data

    const [contactPreferences] = await getUserPreferences({ contactId })

    contact.contactPreferences = contactPreferences

    const yearId = contact.contactPreferences.defaultYear.id
    const schoolId = contact.contactPreferences.defaultSchool.id
    const [userAuth] = await getUserAuths({ contactId, yearId, schoolId })
    contact.userAuth = userAuth

    return contact
  }
}

async function getUserPreferences({ contactId }) {
  if (contactId) {
    let url = 'TzbUserPreferences'
    url += '?filter[where][contactId]=' + contactId
    const response = await http.get(url)
    return response.data
  }
}

async function getUserAuths({ contactId, yearId, schoolId }) {
  if (contactId) {
    let url = 'TzbUserAuths'
    url += '?filter[where][contactId]=' + contactId
    url += '&filter[where][yearId]=' + yearId
    if (schoolId != null) {
      url += '&filter[where][schoolId]=' + schoolId
    }
    url += '&filter[order]=_school.slug ASC'
    const response = await http.get(url)
    return response.data
  }
}

async function updateContactPreferences(prefs) {
  const url = 'TzbUserPreferences' + (prefs.id ? `/${prefs.id}` : '')
  await http.put(url, prefs)
}



// WEBPACK FOOTER //
// ./src/service/contact.js